module.exports = __webpack_public_path__ + "static/main-899e131db19673b63f17c43a9e0d299f.jpg";